import React, { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { formatApiErrorDetail } from "@/lib/api";
import { LogIn, AlertCircle } from "lucide-react";
import UsekoLogo from "@/components/common/UsekoLogo";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const { t } = useLanguage();
  const nav = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admin/dashboard";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [state, setState] = useState({ loading: false, err: null });

  if (user && user !== null && user !== false) return <Navigate to={from} replace/>;

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, err: null });
    try {
      await login(email, password);
      nav(from, { replace: true });
    } catch (err) {
      setState({ loading: false, err: formatApiErrorDetail(err.response?.data?.detail) || err.message });
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F9FA] flex items-center justify-center p-6" data-testid="admin-login">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <UsekoLogo className="h-14 mx-auto"/>
          <h1 className="mt-6 font-heading text-2xl font-bold text-[#102A43]">{t.admin_login_title}</h1>
          <p className="text-sm text-[#4B5563]">{t.admin_login_desc}</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-[#E5E7EB] p-8 space-y-4 shadow-sm">
          <div>
            <label className="block text-sm font-medium text-[#102A43] mb-1.5">E-posta</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full px-4 py-3 rounded-lg border border-[#E5E7EB] focus:border-[#1F8A5B] focus:outline-none focus:ring-2 focus:ring-[#1F8A5B]/10 text-sm"
              data-testid="login-email"/>
          </div>
          <div>
            <label className="block text-sm font-medium text-[#102A43] mb-1.5">{t.admin_password}</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full px-4 py-3 rounded-lg border border-[#E5E7EB] focus:border-[#1F8A5B] focus:outline-none focus:ring-2 focus:ring-[#1F8A5B]/10 text-sm"
              data-testid="login-password"/>
          </div>
          {state.err && (
            <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-800 flex items-start gap-2" data-testid="login-error">
              <AlertCircle className="w-4 h-4 mt-0.5"/>{state.err}
            </div>
          )}
          <button type="submit" disabled={state.loading} className="btn-primary w-full justify-center" data-testid="login-submit">
            {state.loading ? "..." : (<><LogIn className="w-4 h-4"/> {t.admin_signin}</>)}
          </button>
        </form>
      </div>
    </div>
  );
}
